import { isValid } from "date-fns";
import { isString } from "lodash/fp";

export const isValidDate = (value: string | Date) => {
  if (isString(value)) {
    return isValid(new Date(value)) || isValid(new Date(value.split("/").reverse().join("-")));
  }

  return isValid(value);
};
